<template>
  <div class="blog-article">
    <dynamic-image-background class="title-image" :file-id="recipe.image">
    </dynamic-image-background>

    <card class="rounded" style="margin-top: -1em">
      <h6 slot="header" class="text-center">
        {{ recipe.name }}
      </h6>
      <div class="d-flex" style="justify-content: space-evenly;font-size: 0.7rem;font-weight: 600;color: var(--gray);">
        <div v-if="recipe.type == 'breakfast'">Breakfast</div>
        <div v-if="recipe.type == 'lunch'">lunch</div>
        <div v-if="recipe.type == 'dinner'">Dinner</div>

        <div>{{ recipe.duration }} mins</div>
      </div>

      <div class="d-flex mt-3" style="justify-content: space-evenly" v-if="recipe.dish">
        <div class="nutrients-circle">
          <div>
            <div>
              <small>
                <b>
                  {{ recipe.dish['energy(kcal)'] }} k
                </b>
              </small>
            </div>
            <div>
              <small>
                {{ $t('message.Energy') }}
              </small>
            </div>
          </div>
        </div>
        <div class="nutrients-circle">
          <div>
            <div>
              <small>
                <b>
                  {{ recipe.dish['protein(g)'] }} g
                </b>
              </small>
            </div>
            <div>
              <small>
                {{ $t('message.Protein') }}
              </small>
            </div>
          </div>
        </div>
        <div class="nutrients-circle">
          <div>
            <div>
              <small>
                <b>
                  {{ recipe.dish['carbohydrate(g)'] }} g
                </b>
              </small>
            </div>
            <div>
              <small>
                {{ $t('message.Carbs') }}
              </small>
            </div>
          </div>
        </div>
        <div class="nutrients-circle">
          <div>
            <div>
              <small>
                <b>
                  {{ recipe.dish['fat(g)'] }} g
                </b>
              </small>
            </div>
            <div>
              <small>
                {{ $t('message.Fat') }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <el-tabs stretch style="margin-top: 2rem; padding-bottom: 3em; flex-direction: column;" tab-nav-wrapper-classes="illustration-tabs-link w-100" class="illustration-tabs">
        <el-tab-pane :label="$t('message.Directions')" style="text-align: center;">
          <div class="mt-3 text-left" v-html="recipe.directions">

          </div>
        </el-tab-pane>

        <el-tab-pane :label="$t('message.Ingredients')" style="text-align: center;">
          <div>
            <div style="display: flex;align-items: center;justify-content: center;">
              <div>
                <n-button type="primary" round icon simple @click.native="decreamentServes">
                  <i class="fa fa-minus"></i>
                </n-button>
              </div>
              <div class="pl-3 pr-3">
                <div>
                  <i class="fa fa-user"></i>
                </div>
                <div>
                  <small>
                    {{ serves }} <span v-if="serves > 1">{{ $t('message.Serves') }}</span> <span v-else>{{ $t('message.Serve')}}</span>
                  </small>
                </div>
              </div>
              <div>
                <n-button type="primary" round icon simple @click.native="increamentServes">
                  <i class="fa fa-plus"></i>
                </n-button>
              </div>
            </div>

            <div class="ingredients mt-3 text-left">
              <div class="d-flex" style="justify-content: space-between" v-for="ingredient in recipe.ingredients" :key="ingredient.name">
                <div>{{ ingredient.name }}</div>
                <div> {{ ingredient.quantity * serves }} {{ ingredient.unit }}</div>
              </div>
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>

    </card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RadialProgressBar from "vue-radial-progress";
import { TabPane, Tabs } from "src/components";

export default {
  components: {
    RadialProgressBar,
    TabPane,
    Tabs,
  },

  data() {
    return {
      serves: 1,
    };
  },

  methods: {
    increamentServes() {
      this.serves++;
    },
    decreamentServes() {
      if (this.serves == 1) {
        return;
      }
      this.serves--;
    },
  },

  computed: {
    ...mapState({
      recipe: (state) => state.recipe,
    }),
  },
};
</script>

<style scoped>
.ingredients > div {
  margin-top: 0.5em;
}

.title-image {
  position: relative;
  height: 12rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.title {
  position: absolute;
  bottom: 0;
}

.nutrients-circle {
  height: 70px;
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-primary);
  color: white;
  border-radius: 50%;
  text-align: center;
}

/deep/ .illustration-tabs ul.nav.nav-pills {
  justify-content: space-evenly;
}

/deep/ .illustration-tabs .nav-pills .nav-item .nav-link {
  padding: 10px 22px;
  /* border: 1px solid; */
}
</style>


